module.exports = __webpack_public_path__ + "img/stamp-golden-milestone-fishing.10e48717.png";